var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("paginate", {
    attrs: {
      "page-count": _vm.paginator.last_page,
      "page-range": 11,
      "margin-pages": 2,
      "click-handler": _vm.getRecords,
      "prev-text": "&laquo",
      "next-text": "&raquo",
      "container-class": "pagination",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "page-class": "page-item",
      "page-link-class": "page-link",
      "next-class": "page-item",
      "next-link-class": "page-link",
      "active-class": "active green_btn",
    },
    model: {
      value: _vm.paginator.current_page,
      callback: function ($$v) {
        _vm.$set(_vm.paginator, "current_page", $$v)
      },
      expression: "paginator.current_page",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }